<div class='security-form-container' fxLayout='column' fxFill>
  <div fxLayout='column' fxLayoutAlign='space-around' fxFlex>
      <h3 class="text-align-c">
        {{ cService.readyTranslations.security.singleSignOn | uppercase }}
        <div class='margin-t-10 margin-b-10'>
          <mat-divider></mat-divider>
        </div>
        <div *ngIf='!ssoFailed && !signInDone'>
          {{ cService.readyTranslations.messagesAndWarnings.inProgress }}...
        </div>
        <div *ngIf='!ssoFailed && signInDone' class='green-text'>
          {{ cService.readyTranslations.generic.done }}
        </div>
        <div *ngIf='ssoFailed' class='margin-t-25 red-text'>
          <h4>{{ cService.readyTranslations.security.ssoLoggedOutMessage }}</h4>
        </div>
      </h3>
  </div>

  <app-footer></app-footer>
</div>
